import React from 'react'; 
import ReactDOM from 'react-dom/client';
import CreateReactClass from "create-react-class";
import {E_commentsection_keyin, E_Commentsection_initial_ID} from "./main_02_A.js";
import {load_comment_post} from "./main_02_B.js";






var Action = CreateReactClass({
  displayName: "Action",
    getDefaultProps: function getDefaultProps() {
    return {
      number : 0
    };
  },  
  //untuk tambah likes function
_handleKeyPress: function _handleKeyPress(e) {

//to prevent doublereentering of likes.
if (this.props.number == 0) {
//future problem, cause it take another round of clips to get the array here.
var bool = JSON.parse(localStorage.getItem("container"));
bool[1] = bool[1].substring(0, bool[1].length-1);
var num = bool[1].split(",");
var id = bool[0].concat(num.length -1);
  var box = "post_id="+id;
  console.log(box);
  var xhttp = new XMLHttpRequest();
  
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      console.log(this.responseText);
      //container = this.responseText;

    }
  };

  xhttp.open("POST", "php/keyin02.php", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhttp.withCredentials = true;
  xhttp.send(box);

  document.getElementById(id).innerHTML = parseInt(document.getElementById(id).innerHTML) + 1;
  this.props.number = 1;
}
  },
  render: function render() {
    return React.createElement(
      "p",
      { className: "action-button" ,onClick: this._handleKeyPress},
      this.props.text
    );
  }
});


export var Hour = CreateReactClass({
  displayName: "Hour",

  getDefaultProps: function getDefaultProps() {
    return {
      time: 42
    };
  },

  render: function render() {
    return React.createElement(
      "p",
      null,
      this.props.time,
      " h"
    );
  }
});







var Comment = CreateReactClass({
  displayName: "Comment",

  getDefaultProps: function getDefaultProps() {
    return { name: "Douglas Adams" };
  },
  render: function render() {
    return React.createElement(
      "div",

      { className: "single-comment" },
      React.createElement("img", null),
      React.createElement(
        "div",
        { className: "single-container" },
        React.createElement(
          "span",
          null,
          this.props.name
        ),
        React.createElement(
          "span",
          null,
          this.props.children
        )
      ),
      React.createElement(
        "div",
        { className: "buttons" },
        React.createElement(Action, { text: "Like!" }),
        React.createElement(Action, { text: "Respond" }),
        React.createElement(Hour, { time: this.props.time })
      )
    );
  }
});


export function f_comment(id){
 var i = sessionStorage.getItem("i_name");
 console.log("masalha dia" + id);
 var CommentSection = CreateReactClass({
  displayName: "CommentSection",
  getDefaultProps: function getDefaultProps() {
    return {
      id: id, 
      number : 0,
      comment_id: "comment_"+localStorage.getItem("id"),
      url: "url(./profile/assets/php/"+i+"_front.png)",
      police:"police_"+id,
      input_id:"input_"+id
    };
  }, 

  getInitialState: function getInitialState() {
   E_Commentsection_initial_ID(this.props.id);
  
    return {
      comments: []
    };
  },

  _eachComment: function _eachComment(text, i) {
    return React.createElement(
      Comment,
      { key: i, index: i, removeComment: this._deleteComment },
      text
    );
  },

  _addComment: function _addComment(text) {
    var arr = this.state.comments;
    //console.log(this.state.comments);
    //this.setState({ comments: [] });
    
if(text != ""){
    arr.push(text);

    load_comment_post(this.props.id,text);
    //loadpost(this.props.id,text);
   // this.setState({ comments: arr });

    E_commentsection_keyin(text,this.props.id);
    } 
  },

  _handleKeyPress: function _handleKeyPress(e) {
//    if (e.key === "Enter") {
 //     this._addComment(this.refs.newText.value);
 //     this.refs.newText.value = "";
 //     e.preventDefault();
  //  }
  },

   _handlecomment: function _handlecomment(e) {
  var arr = this.state.comments;
    console.log(this.state.comments);
    //this.setState({ comments: [] });
    if(this.refs.newText.value != ""){
    arr.push(this.refs.newText.value);
    load_comment_post(this.props.id,this.refs.newText.value,i);
    //loadpost(this.props.id,text);
   // this.setState({ comments: arr });
    E_commentsection_keyin(this.refs.newText.value,this.props.id); 
     this.refs.newText.value = "";
   }
  },

  render: function render() {
//i put the span, as an acnhor by make it invisible, hidden however the properties does still exist
    return React.createElement(
      "div",
      {className:"Container_app3",style: {display: "none"},id:this.props.id.concat("_M")},
      React.createElement(
        "div",
        { className: "comment-section hai yo", id:this.props.id.concat("_C")},
        this.state.comments.map(this._eachComment)
      ),
       React.createElement("span",{className:"anchor", id: this.props.comment_id},"span"),
      React.createElement(
        "div",
        { className: "input",id: this.props.input_id},
        React.createElement("img", {style: {backgroundImage: this.props.url}}),
        React.createElement("div",null,React.createElement("textarea", { ref: "newText", onKeyPress: this._handleKeyPress, placeholder: "Write a comment..."}), React.createElement("div",{className:"div_input"},React.createElement("div",{},React.createElement("i",{className:"fa fa-paper-plane",onClick: this._handlecomment},React.createElement("span",{}," Post"))))     
      )), React.createElement(
        "div",
        { className: "police_input",id:this.props.police },React.createElement("p",null,"please Login to comment..Thanks")
      )
    );
  }
});

return CommentSection;
}

